class MainMenu {
  constructor(el) {
    this.opened = false
    this.el = el
    this.drawer = el.querySelector('.menu-container')
    this.hamburger = el.querySelector('.hamburger')
    this.hamburger.addEventListener('click', () => {
      this.toggle()
    })

    // Initialize expand buttons for menus
    const menuItems = el.querySelectorAll('li')

    menuItems.forEach(item => {
      const hasChildren = item.querySelectorAll('ul').length

      if (hasChildren) {
        item.classList.add('has-children')
        item.querySelector('a')
          .setAttribute('aria-haspopup', 'true')
        item.querySelector('a')
          .setAttribute('aria-expanded', 'true')

        item.querySelector('a').addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()
          
          if (window.innerWidth < 1280) {
            if (item.classList.contains('active')) {
              item.classList.remove('active')
            } else {
              menuItems.forEach(x => x.classList.remove('active'))
              item.classList.add('active')
            }
          }
        })
      }
    })

    // Close the menu when the viewport reaches desktop, so the open-state
    // (.active) classes don't linger after a resize / orientation change.
    this.desktopQuery = window.matchMedia('(min-width: 1280px)')
    this.desktopQuery.addEventListener('change', (e) => {
      if (e.matches && this.opened) {
        this.close()
      }
    })

    // Close the menu when the user interacts outside the header (mobile).
    this.handleOutsideInteraction = (event) => {
      if (!this.opened) {
        return
      }
      if (!this.el.contains(event.target)) {
        this.close()
      }
    }
    document.addEventListener('click', this.handleOutsideInteraction)
    document.addEventListener('touchstart', this.handleOutsideInteraction)

    // Close the menu when an in-page ISI anchor link is activated, so the open
    // drawer doesn't cover the Important Safety Information it scrolls to.
    this.handleIsiLink = (event) => {
      if (!this.opened) {
        return
      }
      const link = event.target.closest ? event.target.closest('a[href*="#isi"]') : null
      if (link) {
        this.close()
      }
    }
    document.addEventListener('click', this.handleIsiLink)

    // Close the menu when the user presses Escape.
    this.handleEscape = (event) => {
      if (this.opened && event.key === 'Escape') {
        this.close()
      }
    }
    document.addEventListener('keydown', this.handleEscape)
  }

  open() {
    this.hamburger.classList.add('active')
    this.drawer.classList.add('active')
    this.opened = true

    // emit event to let other menus know this menu is opening
    const event = new CustomEvent('main-menu-toggle', {
      detail: {
        open: true
      }
    })
    window.dispatchEvent(event)
  }

  close() {
    this.hamburger.classList.remove('active')
    this.drawer.classList.remove('active')
    this.opened = false
    // emit event to let other menus know this menu is closing
    const event = new CustomEvent('main-menu-toggle', {
      detail: {
        open: false
      }
    })
    window.dispatchEvent(event)
  }

  toggle() {
    if (this.opened) {
      this.close()
    } else {
      this.open()
    }
  }
}

export default MainMenu
